import { render } from "./SquarePayment.vue?vue&type=template&id=2edc9087&scoped=true"
import script from "./SquarePayment.vue?vue&type=script&lang=js"
export * from "./SquarePayment.vue?vue&type=script&lang=js"

import "./SquarePayment.vue?vue&type=style&index=0&id=2edc9087&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2edc9087"]])

export default __exports__